import objectPath from 'object-path';

// src/utils/index.ts
var getColorByToken = (theme, token) => objectPath.get(theme, token);
var addHexOpacity = (hex, value) => hex.substring(0, 7) + Math.floor(value * 255).toString(16).padStart(2, "0").toUpperCase();

export { addHexOpacity, getColorByToken };
